import * as React from 'react';

import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';
import { MapEntry } from '../../components/MapEntry';
import { selectListingsUrls } from '../../selectors/listingsUrls';

export const MapEntryContainer: React.FC = () => {
  const { mapUrl } = useSelector(selectListingsUrls);

  if (!mapUrl) {
    return null;
  }

  return (
    <Responsive phone tablet>
      <MapEntry mapUrl={mapUrl} />
    </Responsive>
  );
};
